import { useStaticQuery, graphql } from "gatsby";

// Returns all Craft sites from the /v1/languages REST endpoint (fetched at build time).
// Falls back to [] if unreachable — components derive site list from allManuals in that case.

const query = graphql`
  query AllCraftSitesQuery {
    allCraftSite {
      nodes {
        craftSiteId
        name
        language
        locale
        handle
        primary
        enabled
      }
    }
  }
`;

let cache;

const useData = () => {
  const response = useStaticQuery(query);
  if (cache) return cache;
  cache = (response?.allCraftSite?.nodes || []).filter(s => s.enabled !== false);
  return cache;
};

export default useData;
